<template>
  <div>
    <cart-added-popup :show="showCartAdded"></cart-added-popup>
    <cart-add-dialog
      ref="cartAddDialog"
      :show="cartAddDialogShow"
      :data='cartAddDialog'
      @close='onCloseCartAddDialog'></cart-add-dialog>

    <ntc-cart-add-dialog
      ref="ntcCartAddDialog"
      :show="ntcCartAddDialogShow"
      @close='onCloseNtcCartAddDialog'></ntc-cart-add-dialog>
  </div>
</template>
<script>
import AroBase from '@/components/base/AroBase';
import CartAddedPopup from '@/components/popup/CartAdded';
import CartAddDialog from '@/components/popup/CartAddDialog';
import NtcCartAddDialog from '@/components/popup/NtcCartAddDialog';
import * as Const from "@/utils/const";
import * as ErrMsg from "@/utils/error_msg";

export default {
  name: "popupAddInAroCart",
  extends: AroBase,
  components: { CartAddedPopup, CartAddDialog, NtcCartAddDialog},
  computed: {
    isNuskinChannel : function() {
      return this.$aroChannel == Const.ARO_CHANNEL_NUSKIN;
    }
  },
  props:{
  },
  data: () => ({
    //View Data
    showCartAdded : false,
    cartAddDialogShow : false,
    cartAddDialog : {
      rawData : {
        countPerPage: 5,
        page: 1,
        totalCount: 0,
        //...
      },
      resData : {
        addTo : "CART", //장바구니:CART, aro_no:기존Aro에 추가
        aroData : null,
      }
    },

    ntcCartAddDialogShow : false,
    ntcCartAddDialog : {
      rawData : {
        //...
      },
      resData : {
        addTo : "", //aro_no:기존Aro에 추가
        aroData : null,
      }
    },

    testText : ""
  }),
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  watch:{
  },
  methods: {
    /**
     * API Request
     */
    //장바구니에 상품 추가
    apiAddProductInCart : function(pd_id, pd_count, division_code){
      let _this = this;

      let pdAddList = [
        {
          pd_id : pd_id,
          pd_count : pd_count,
          division_code : division_code
        }
      ];

     return _this.$http.get(`${_this.$aroApiBasePath}/aro/put_cart`, {
        params: {
          pd_add_list : JSON.stringify(pdAddList)
        },
        paramsSerializer: function (params) {
          return require('qs').stringify(params, {arrayFormat: 'brackets'})
        },
      });
    },

    //나의 ARO 정보 가져오기
    apiGetAro : function(pageNo){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_aro`, {
        params: {
          isUspan : "N",
          page : pageNo,
          countPerPage : _this.cartAddDialog.rawData.countPerPage
        }
      });
    },

    //상품 상세 가져오기
    apiGetProductDetail : function(pd_id){
      let _this = this;
      return _this.$http.get(`${_this.$aroApiBasePath}/aro/product/detail`, {
        params: {
          pd_id :pd_id
        }
      });
    },

    //ARO 변경 가능 여부 체크
    apiCheckAroModifyStatus : function(aro_no){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/modify_status`, {
        params: {
          adpNo : aro_no
        }
      });
    },

    //나의 ARO에 상품 추가
    apiAddProductInAro : function(aro_no, pd_id, pd_count){
      let _this = this;

      let pdAddList = [
        {
          pd_id : pd_id,
          pd_count : pd_count
        }
      ];

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/add_products`, {
        params: {
          aro_no : aro_no,
          pd_add_list : JSON.stringify(pdAddList)
        },
        paramsSerializer: function (params) {
          return require('qs').stringify(params, {arrayFormat: 'brackets'})
        },
      });
    },

    //나의 Ntc 정보 가져오기
    apiGetNtc : function(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_ntc`, {
        params: {}
      });
    },

    //Ntc 장바구니에 상품 추가
    apiAddProductInNtcCart : function(pd_id, pd_count){
      let _this = this;

      let pdAddList = [
        {
          pd_id : pd_id,
          pd_count : pd_count
        }
      ];

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/ntc/add_carts`, {
        params: {
          pd_add_list : JSON.stringify(pdAddList)
        },
        paramsSerializer: function (params) {
          return require('qs').stringify(params, {arrayFormat: 'brackets'})
        },
      });
    },

    //나의 NTC ARO에 상품 추가
    apiAddProductInNtcAro : function(pd_id, pd_count){
      let _this = this;

      let pdAddList = [
        {
          pd_id : pd_id,
          pd_count : pd_count
        }
      ];

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/ntc/post_products`, {
        params: {
          pd_list : JSON.stringify(pdAddList)
        },
        paramsSerializer: function (params) {
          return require('qs').stringify(params, {arrayFormat: 'brackets'})
        },
      });
    },

    /**
     * Local function
     */

    /**
     * 장바구니 관련
     */
    //장바구니 추가
    onClickAddCart(pd_id, division_code, pd_count){
      let _this = this;

      if(!_this.isLogined()){
        //비 로그인시
        _this.$openLoginConfirm();
        return;
      }

      let pdCount = pd_count ? pd_count : 1;

      let isNtc = _this.AroConst.ARO_NTC_PRODUCT_IDS.includes(pd_id);
      if(isNtc){
        _this.addCartNtcProduct(pd_id, pdCount);
      }else{
        _this.apiGetProductDetail(pd_id).then((res)=>{
          if (res.status === 200 && res.data.status === "0000") {

            if(res.data.isSoldOut == 'Y'){
              _this.$dialogs.alert('품절된 상품입니다.').then(res => {});
              return;
            }else{
              _this.addCartNormalProduct(pd_id, division_code, pdCount);
            }

          }else{
            //console.error(res);
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
            _this.$dialogs.alert(errMsg)
            .then(res => {});
          }
        }).catch((err)=>{
          console.error(err);

          _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
          .then(res => {});

        }).finally(()=>{
          _this.$hideLoading();
        });
      }
    },

    //일반상품 장바구니 담기
    addCartNormalProduct(pd_id, division_code, pd_count){
      let _this = this;

      let reqPageNo = 1;
      _this.$showLoading();
      _this.apiGetAro(reqPageNo).then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.cartAddDialog.rawData = res.data;

          if(!_this.cartAddDialog.rawData.totalCount || _this.cartAddDialog.rawData.totalCount <= 0){
            // ARO내역이 없으면, 바로 장바구니에 추가
            return _this.apiAddProductInCart(pd_id, 1, division_code);
          }

          //정기구매 선택 Dialog 표시
          _this.cartAddDialog.targetProduct = {
            pd_id : pd_id, division_code : division_code, pd_count : pd_count ? pd_count : 1,
          };
          _this.$refs.cartAddDialog.initData();
          _this.cartAddDialogShow = true;
        }else{
          //console.error(res);
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

        return null;
      }).then(res=>{
        if(res){
          if (res.status === 200 && res.data.status === "0000") {
            _this.showCartAdded = true;
            setTimeout(()=>{
              _this.showCartAdded = false;
            }, 1000);

            //장바구니 변경 handler
            _this.$changeBasketCount();
          }else{
            //console.error(res);
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
            _this.$dialogs.alert(errMsg)
            .then(res => {});
          }
        }
      }).catch((err)=>{
        console.error(err);

        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        _this.$hideLoading();
      });
    },

    //장바구니 다이얼로그 처리
    onCloseCartAddDialog(isOk, data) {
      let _this = this;
      _this.cartAddDialogShow = false;

      if(!isOk){
        //Do nothing.
        return;
      }

      //장바구니 직접등록 or 기존 aro 에 추가
      let retData = data;

      let pd_id = _this.cartAddDialog.targetProduct.pd_id;
      let division_code = _this.cartAddDialog.targetProduct.division_code;
      let pd_count = _this.cartAddDialog.targetProduct.pd_count;
      let targetAro = retData.resData.aroData;

      if(retData.resData.addTo === "CART"){
        //장바구니에 추가
        _this.$showLoading();
        _this.apiAddProductInCart(pd_id, pd_count, division_code).then((res)=>{
          if (res.status === 200 && res.data.status === "0000"){
            //장바구니에 추가 popup
            _this.showCartAdded = true;
            setTimeout(()=>{
              _this.showCartAdded = false;
            }, 1000);

            //장바구니 변경 handler
            _this.$changeBasketCount();
          }else{
            //console.error(res);
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
            _this.$dialogs.alert(errMsg)
            .then(res => {});
          }
        }).catch((err)=>{
          //console.error(err);

          _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
          .then(res => {});

        }).finally(()=>{
          _this.$hideLoading();
        });

      }else{
        //기존 ARO에 추가
        _this.$showLoading();
        _this.apiCheckAroModifyStatus(retData.resData.addTo).then((res)=>{
          if (res.status === 200 && res.data.status === "0000") {
            return _this.apiAddProductInAro(retData.resData.addTo, pd_id, pd_count);

          }else{
            //console.error(res);
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
            _this.$dialogs.alert(errMsg)
            .then(res => {});
            return null;
          }
        }).then((res)=>{
          if(res){
            if (res.status === 200 && res.data.status === "0000") {
              //기존 ARO에 추가 결과 msg
              let msg = '';
              msg += `정기구매 ${targetAro.aro_no}(${targetAro.subject})에 상품을 추가 하였습니다.<br/>`;
              msg += '동일한 상품이 있는 경우 자동으로 수량이 추가됩니다.<br/>';
              msg += '추가한 상품은 해당 정기결제일에 합산하여 배송됩니다.';

              _this.$dialogs.alert(msg).then(res => {});

            }else{
              //console.error(res);
              let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
              _this.$dialogs.alert(errMsg)
              .then(res => {});
            }
          }
        }).catch((err)=>{
          console.error(err);

          _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
          .then(res => {});

        }).finally(()=>{
          _this.$hideLoading();
        });
      }
    },

    //NTC 상품 장바구니 담기
    addCartNtcProduct(pd_id, pd_count){
      let _this = this;

      _this.$showLoading();
      _this.apiGetNtc().then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.ntcCartAddDialog.rawData = res.data;

          if(!_this.ntcCartAddDialog.rawData.ntcNo &&
            _this.ntcCartAddDialog.rawData.ntc_status != "1"){
            // ARO내역이 없으면, 바로 ntc 장바구니에 추가
            return _this.apiAddProductInNtcCart(pd_id, pd_count);
          }

          //정기구매 선택 Dialog 표시
          _this.ntcCartAddDialog.targetProduct = {
            pd_id : pd_id, pd_count : pd_count,
            pd_type : "ntc", //Ntc 상품
          };
          _this.$refs.ntcCartAddDialog.initData(_this.ntcCartAddDialog);
          _this.ntcCartAddDialogShow = true;
        }else{
          //console.error(res);
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

        return null;
      }).then(res=>{
        if(res){
          if (res.status === 200 && res.data.status === "0000") {
            //장바구니 추가 완료 표시
            _this.showCartAdded = true;
            setTimeout(()=>{
              _this.showCartAdded = false;
            }, 1000);

            //장바구니 변경 handler
            _this.$changeBasketCount();

          }else{
            //console.error(res);
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
            _this.$dialogs.alert(errMsg)
            .then(res => {});
          }
        }
      }).catch((err)=>{
        console.error(err);

        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        _this.$hideLoading();
      });
    },

    //NTC 장바구니 다이얼로그 처리
    onCloseNtcCartAddDialog(isOk, data) {
      let _this = this;
      _this.ntcCartAddDialogShow = false;

      if(!isOk){
        //Do nothing.
        return;
      }

      //기존 aro 에 추가
      let retData = data;

      let pd_id = _this.ntcCartAddDialog.targetProduct.pd_id;
      let pd_count = _this.ntcCartAddDialog.targetProduct.pd_count;
      let pd_type = _this.ntcCartAddDialog.targetProduct.pd_type;
      let targetAro = retData.resData.aroData;

      //기존 ARO에 추가
      _this.$showLoading();
      _this.apiAddProductInNtcAro(pd_id, pd_count).then((res)=>{
        if (res.status === 200 && res.data.status === "0000") {
          //기존 ARO에 추가 결과 msg
          let msg = '';
          msg += `정기기부 ${targetAro.ntcNo}에 상품을 추가 하였습니다.<br/>`;
          msg += '동일한 상품이 있는 경우 자동으로 수량이 추가됩니다.<br/>';
          msg += '추가한 상품은 해당 정기 결제일에 합산하여 결제됩니다.';

          _this.$dialogs.alert(msg).then(res => {});

        }else{
          //console.error(res);
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }
      }).catch((err)=>{
        console.error(err);

        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        _this.$hideLoading();
      });
    },

    //GA 전송-장바구니 클릭
    sendGaProductToCart(prod, qty){
      let _this = this;

      let price = parseInt(""+prod.pd_amt1, 10);

      let gaData = {
        event: 'addToCart_ARO',
        ecommerce: {
          add: {
            currencyCode: 'KRW',
            products : [
              {
                name: prod.pd_name_kr,
                id: prod.pd_id,
                price: price,
                brand: prod.brandName ? prod.brandName : '',
                category: prod.categoryName ? prod.categoryName : '',
                variant : 'ARO',
                quantity: qty
              },
            ]
          }
        }
      };

      _this.$sendAroGA(gaData);
    },
  }
};
</script>
<style>
a.rew19_btnPre, a.rew19_btnNext, a.rew19_basket_oder{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/integration/popupAddInAroCart.vue